const LOCALES_PT = {
  about: 'Sobre Nós',
  services: 'Serviços',
  contacts: 'Contactos',
  news: 'Notícias',
  followUs: 'Segue-nos no ',
  goBack: 'Voltar',
  pageNotFound: 'Página Não Encontrada',
};
export default LOCALES_PT;
